import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

class Line extends PureComponent {
    render() {
        const style = {
            width: this.props.width,
            minWidth: this.props.width,
            display: 'inline-block',
            height: 20,
            minHeight: 20,
        };
        return <div className={this.props.color} style={style} />;
    }
}

Line.propTypes = {
    width: PropTypes.string.isRequired,
    color: PropTypes.string.isRequired,
};

export default Line;
